import API from "@lib/axiosConfig";

export default (url, body) => API.put(url, body);
